var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("step-by-step-guide-data-provider", {
    attrs: {
      "initial-step-id": _vm.initialStepId,
      "step-ids": _vm.stepIdsArray,
      "api-url": _vm.apiUrl
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(dataProvider) {
          return _c(
            "div",
            {},
            [
              _c("guide-steps", {
                attrs: { "guide-steps": dataProvider.guideSteps },
                on: { fetchStep: dataProvider.fetchStep }
              }),
              _vm._v(" "),
              dataProvider.loading
                ? _c("div", { staticClass: "c-spinner" })
                : _vm._e()
            ],
            1
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }